import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import St from './TermsOfServiceScreen.module.css';

const TermsOfServiceScreen = () => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <div className={St.page}>
      <div className={St.container}>
        {window.history.length > 1 ? (
          <button className={St.back} onClick={() => history.goBack()}>
            {t('screens.legal.back')}
          </button>
        ) : null}
        <h1>{t('screens.legal.tosSimpleTitle')}</h1>
        <p className={St.updated}>{t('screens.legal.lastUpdatedShort')}</p>

        <h2>{t('screens.legal.tosSimpleH1')}</h2>
        <p>{t('screens.legal.tosSimpleP1')}</p>

        <h2>{t('screens.legal.tosSimpleH2')}</h2>
        <p>{t('screens.legal.tosSimpleP2')}</p>

        <h2>{t('screens.legal.tosSimpleH3')}</h2>
        <p>{t('screens.legal.tosSimpleP3')}</p>

        <h2>{t('screens.legal.tosSimpleH4')}</h2>
        <p>{t('screens.legal.tosSimpleP4')}</p>

        <h2>{t('screens.legal.tosSimpleH5')}</h2>
        <p>{t('screens.legal.tosSimpleP5')}</p>

        <h2>{t('screens.legal.tosSimpleH6')}</h2>
        <p>{t('screens.legal.tosSimpleP6')}</p>

        <h2>{t('screens.legal.tosSimpleH7')}</h2>
        <p>{t('screens.legal.tosSimpleP7')}</p>

        <h2>{t('screens.legal.tosSimpleH8')}</h2>
        <p>{t('screens.legal.tosSimpleP8')}</p>

        <h2>{t('screens.legal.tosSimpleH9')}</h2>
        <p>{t('screens.legal.tosSimpleP9')}</p>

        <h2>{t('screens.legal.tosSimpleH10')}</h2>
        <p>{t('screens.legal.tosSimpleP10')}</p>

        <h2>{t('screens.legal.tosSimpleH11')}</h2>
        <p>
          {t('screens.legal.tosSimpleP11Prefix')}<a href='mailto:legal@regure.com'>legal@regure.com</a>{t('screens.legal.tosSimpleP11Suffix')}
        </p>
      </div>
    </div>
  );
};

export default TermsOfServiceScreen;
